import { KebabMenu } from '@modules/common/components/KebabMenu';
import { MenuItemOptions } from '@modules/common/components/KebabMenu/types';
import { useExportFeedbackViaEmail } from '@modules/common/hooks';
import { ChatRounded } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { QueryContainer } from 'v2/core/services/notebook/types';
import { useGetExportFeedbackRecordsModal } from 'v2/views/components/ExportFeedbackRecordsModalContent/hooks';

interface FeedbackListDrawerActionMenuProps {
  queryContainer: QueryContainer;
  feedbackCount?: number;
}

export const FeedbackListDrawerActionMenu = ({
  queryContainer,
  feedbackCount,
}: FeedbackListDrawerActionMenuProps) => {
  const [exportFeedbackViaEmail] = useExportFeedbackViaEmail({
    exportedFrom: 'Feedback Drawer',
  });

  const exportFeedbackModal = useGetExportFeedbackRecordsModal({
    exportFeedback: async ({ includeContent, includeOriginalContent }) => {
      await exportFeedbackViaEmail({
        queryContainer,
        includeContent,
        includeOriginalContent,
      });
    },
    feedbackCount: feedbackCount,
  });

  const kebabMenuItems: MenuItemOptions = [
    {
      icon: <ChatRounded fontSize="small" />,
      label: <Typography>Export Feedback</Typography>,
      onClick: exportFeedbackModal,
    },
  ];

  return (
    <KebabMenu
      menuItems={kebabMenuItems}
      buttonProps={{
        color: 'primary',
        size: 'small',
      }}
      menuProps={{
        PaperProps: {
          sx: {
            minWidth: '150px',
          },
        },
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center',
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },
      }}
    />
  );
};
